import { connect } from 'react-redux'
import { getApper, saveXiaoJia } from './actions'
import Setting from './main'


const mapDispatchToProps = {
    getApper,
    saveXiaoJia
}
const mapStateToProps = (state) => {
  return {
    ...state.XiaoJiaEditor
  }
}
  

export default connect(mapStateToProps, mapDispatchToProps)(Setting)
